module.exports = __webpack_public_path__ + "statics/img/10.49a91ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo/10.jpg
// module id = v8du
// module chunks = 1